import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  newsletter: belongsTo('newsletter', { inverse: null }),
});
